import React from "react";
// react plugin that creates an input with badges
import {globals,video_form} from '../Globals/Globals'
import {useSelector, useDispatch } from 'react-redux';
import { closeModalVideo } from '../../redux/modalSlice'; 
import { updateVideo, addVideo } from '../../redux/videoSlice';
import {Button, Container } from "reactstrap";
import { openModal } from "../../redux/modalSlice";
// core components
import {DsDynamicForm} from "datasync-dynamic-form";
import "../../Components/Modal/Modal.css";

const VideoFormDialog = () => {
  const {videoModal} = useSelector((state) => state.modal);
  const user_foreign_keys = useSelector((state) => state.auth.user_guid);
  const dispatch = useDispatch();
  const {isAdmin} = useSelector((state) => state.auth);
  const {isReadOnly} = useSelector((state) => state.modal);

  React.useEffect(() => {
    console.log("videoModal -> ",videoModal);
    console.log("videoModal.activeObject -> ",videoModal.activeObject);
    console.log("user_foreign_keys ->",user_foreign_keys);

    return function cleanup() {
      document.body.classList.remove("discover");
    };
  });

  return (
      <>
        <div className="main modal-overlay">
          <Button className="modal-top-right-close-button" onClick={()=>{dispatch(closeModalVideo())}}>Fermer</Button>
          <div className="dialog-container">
            <Container>
              {videoModal.activeObject &&
              <h1>{videoModal.activeObject.data_blob.data_tier.video_title}</h1>}
              {videoModal.activeObject===null &&
              <h1>{"<Url de la vidéo>"}</h1>}
              
              <DsDynamicForm
                col_lg={12}
                datasync_url = {globals.datasync_service.url}
                form = {video_form}
                company_guid = {globals.datasync.platform_company_guid}
                table_guid= {globals.datasync.pf_videos_table_guid}
                onFormSaved = {(saved_data) => {dispatch(openModal({title:"Vidéo enregistrée"})); console.log("VideoFormDialog::saved_data ->",saved_data);dispatch(addVideo(saved_data)); dispatch(closeModalVideo());}}
                //Let us update the articl
                onFormUpdated = {(updated_data) => {dispatch(openModal({title:"Vidéo modifiée"})); console.log("VideoFormDialog::updated_data ->",updated_data); dispatch(updateVideo(updated_data)); dispatch(closeModalVideo());}}
                onFormFailed = {() => {if (globals.parameters.save_failed_alert) dispatch(openModal({title:"Erreur de sauvegarde de la vidéo"}))}}
                clearOnSave = {true}
                clearOnUpdate = {true}
                sticky_button = {true}
                custom_button_handler = {() => {dispatch(closeModalVideo())}}
                custom_button_caption = {"Fermer"}
                //---
                datasync_object = {videoModal.activeObject}
                data_blob = {videoModal.activeObject?videoModal.activeObject.data_blob:null}
                show_hidden = {isAdmin}
                foreign_keys = {videoModal.activeObject==null?{"user_guid":user_foreign_keys}:null}
                read_only = {isReadOnly}
              />
            </Container>
          </div>
        </div>
      </>
    );
  }

export default VideoFormDialog;
